<div class="main-db gap-top">
    <div class="container-fluid mt-2">


        <div class="col-12">          
            <h1>{{title}}</h1>
        </div>


        <div class="card">
            <div class="card-header font-weight-bold row">
                <h5 class="col-6">{{titleTicketPrice}}</h5>
            </div>

            <div class="card-body">
                <form class="row" [formGroup]="ticketPriceForm">


                    <div class="col-2 pr-0 mt-2 mt-sm-0">
                      <input type="date" class="form-control form-control-sm input-custom" formControlName="date" placeholder="Date"/>
                    </div>
            
                    <div class="col-2 pr-0 mt-2 mt-sm-0">
                        <input type="number" class="form-control form-control-sm input-custom" formControlName="amount" placeholder="Amount"/>
                    </div>
            
              
                    <div class="col-sm-5 col-12 mt-2 mt-sm-0">
                      <button [disabled]="!ticketPriceForm.valid" [hidden]="updateMode" class="btn btn-sm btn-success float-left" (click)="addTicketPrice()">
                        <i class="fas fa-plus mr-1"></i> Add
                      </button>
                      
                      <button [disabled]="!ticketPriceForm.valid" [hidden]="!updateMode" class="btn btn-sm btn-success float-left" (click)="updateLprWhiteList()">        
                        <i class="fa fa-pencil mr-1"></i> Update
                      </button>
              
                      <button class="btn btn-sm btn-success float-left ml-2" (click)="resetForm()">
                        <i class="fa fa-refresh mr-1"></i> Clear
                      </button>
              
                    </div>
                  </form>





                  <div class="container-fluid mt-4">
                    <div class="row">
                      <div class="col-xl-12 col-xl-5">
                        <div class="">
                          <input type="text" class="form-control form-control-sm input-custom" (keyup)="applyFilter($event)" placeholder="Search"/>
                        </div>
                      </div>
                    </div>
                  </div>
                
                  <div class="container-fluid mt-2">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="db-block table-responsive" style="height: auto !important">
                            <i class="fa fa-database mr-2" aria-hidden="true"></i>
                            <span>{{titleTicketPrice}}</span>
              
                            <!-- <a type="button" class="float-right" (click)="excelSheetDownload()">
                              <i class="fa fa-download mr-1" aria-hidden="true"></i> Export CSV
                            </a>
                            <a type="button" class="float-right mr-2" (click)="sampleCSV()">
                              <i class="fa fa-download mr-1" aria-hidden="true"></i> Sample CSV
                            </a> -->
              
                            
                          <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
                            <ng-container matColumnDef="date">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                              <td mat-cell *matCellDef="let element">{{ element.date | date : "dd-MM-y" }}</td>
                            </ng-container>
                
                            <ng-container matColumnDef="amount">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
                              <td mat-cell *matCellDef="let element">{{ element.amount }}</td>
                            </ng-container>
              
                
                            <ng-container matColumnDef="actions">
                              <th mat-header-cell *matHeaderCellDef>Action</th>
                              <td mat-cell *matCellDef="let element">
                                  <button mat-icon-button matTooltip="Click to Edit" class="iconbutton text-warning">
                                      <mat-icon aria-label="Edit" (click)="setUpdateMode(element)">edit</mat-icon>
                                  </button>
                                
                                  <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePrompt2">
                                      <mat-icon aria-label="Delete">delete</mat-icon>
                                  </button>                 
                                  
                                  <!-- Modal -->
                                  
                                  <div class="modal fade" id="deletePrompt2" tabindex="-1" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                                      <div class="modal-dialog" role="document">
                                          <div class="modal-content">
                                              <div class="modal-header">
                                                  <h5 class="modal-title orange-text" id="deletePromptLabel">Delete License Plate </h5>
                                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                      <span aria-hidden="true">&times;</span>
                                                  </button>
                                              </div>
                                              <div class="modal-body">
                                                  Are you sure you want to delete Ticket Price?
                                              </div>
                                              <div class="modal-footer">
                                                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                                  <button type="button" class="btn btn-danger" (click)="deleteTicketPrice(tempId)" data-dismiss="modal">Confirm</button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </td>
                            </ng-container>
                
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                          </table>
                          <mat-paginator [pageSizeOptions]="[10,25]"></mat-paginator>
                        </div>
                      </div>
                    </div>
                  </div>


            </div>
        </div>


    </div>

  
</div>
  